import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, browserHistory } from "react-router";

import BacktestService from "../../service/backtest.service";

class Login extends Component {
  state = {
    empty: false,
    error: "",
    display:"none",
    submitted:false,
    form: {
      username: "",
      password: "",
    },
  };
  componentDidUpdate(){
    console.log("Component has been updated");
    console.log(this.state.form);

    if(this.state.form.username && this.state.form.password && !this.state.submitted){
      this.setState({submitted:true});
      this.login();
    }
  }
  componentDidMount(){
    console.log(this.props);
    let showLoginForm = true;
    if(this.props.location.search){
      let qs =  this.props.location.search;
      qs = qs.replace(/^\?/, "");
      console.log(qs);
      if(!qs.startsWith("back")){
        let usr =  atob(qs);
        console.log(usr);
        usr = Object.fromEntries(new URLSearchParams(usr));
        console.log(usr);
        if(usr.user && usr.pass){
          //username and password exists in qs.  lets populate the logi form and submit the same
          showLoginForm = false;  
          let tempForm = {username:usr.user,password:usr.pass}
          this.setState({form:tempForm});
          // this.props.login();
          }
      }
    }
    if(showLoginForm){
      this.setState({display:"block"});
    }
  }

  login(e) {
    console.log("Submitting login form...");
    if (e)
      e.preventDefault();

    this.setState({ empty: false });

    if (!this.state.form.username.length || !this.state.form.password.length) {
      this.setState({ empty: true });
    } else {
      BacktestService.login(this.state.form).then((res) => {
        if ("detail" in res) {
          this.setState({
            error: res.detail.join("\n"),
            empty: true,
          });
        } else if ("token" in res) {
          this.props.login({
            token: res.token,
            username: this.state.form.username,
          });
          if ("back" in this.props.location.query)
            browserHistory.push(this.props.location.query.back);
          else browserHistory.push("/");

          BacktestService.getUserPreferences().then((res) => {
            //TODO : if simulations in res is false do not allow portfolio creation/modification/upload universe
            //[{"username": "iqciodev", "first_name": "", "last_name": "", "is_staff": false, "is_active": true, "simulations": null, "company": null, "region": null}]
            if (res) {
              this.props.setUserPreferences(res[0]);
            }
          });
        }
      });
    }
  }

  handleChange(e) {
    let { name, value } = e.target;
    this.setState({
      form: {
        ...this.state.form,
        [name]: value,
      },
    });
  }

  render() {
    return (
      <div className="login" style={{display:this.state.display}}>
        <div className="logo">
          <Link to={"/"}>
            <img src="/assets/images/logo.png" alt="iqCIO" />
          </Link>
        </div>
        <div className="content">
          <form
            className="login-form"
            onSubmit={this.login.bind(this)}
            method="post"
            id="loginForm"
          >
            <h3 className="form-title font-green">Sign In</h3>
            {this.state.empty ? (
              <div className="alert alert-danger">
                <button className="close" data-close="alert"></button>
                <span>
                  {" "}
                  {!this.state.error.length ? (
                    <span>Enter any username and password.</span>
                  ) : (
                    <span>{this.state.error}</span>
                  )}{" "}
                </span>
              </div>
            ) : null}
            <div className="form-group">
              <label className="control-label visible-ie8 visible-ie9">
                Username
              </label>
              <input
                className="form-control form-control-solid placeholder-no-fix"
                type="text"
                autoComplete="off"
                placeholder="Username"
                name="username"
                onChange={this.handleChange.bind(this)}
                value={this.state.form.username}
              />
            </div>
            <div className="form-group">
              <label className="control-label visible-ie8 visible-ie9">
                Password
              </label>
              <input
                className="form-control form-control-solid placeholder-no-fix"
                type="password"
                autoComplete="off"
                placeholder="Password"
                name="password"
                onChange={this.handleChange.bind(this)}
                value={this.state.form.password}
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn green uppercase">
                Login
              </button>
              <label className="rememberme check mt-checkbox mt-checkbox-outline">
                <input type="checkbox" name="remember" value="1" />
                Remember
                <span></span>
              </label>
              <a href="" id="forget-password" className="forget-password">
                Forgot Password?
              </a>
            </div>
          </form>
        </div>
        <div className="copyright">
          {" "}
          &copy; IQCIO - REINVENT YOUR PORTFOLIO WITH INTELLIGENCE {" "}
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    user: state.user,
  }),
  (dispatch) => ({
    login: (credentials) => {
      dispatch({ type: "LOGIN", payload: { credentials } });
    },
    setUserPreferences: (payload) => {
      dispatch({
        type: "SET_USER_PREFERENCES",
        payload,
      });
    },
  })
)(Login);



// WEBPACK FOOTER //
// ./src/components/pages/Login.jsx